module.exports = ".app-container {\n  max-width: 1280px;\n  margin: auto; }\n"